const inside = () => {
    $(".rio-team .list-icon-members .icon-member").hover(function(){
        const index = $(this).index()
        let preLink = $(".list-icon-members .icon-member.active").data('icon')
        $(".list-icon-members .icon-member.active").css({
            'background-image': `url(${preLink})`,
        })
        $(".list-icon-members .icon-member.active").removeClass("active");
        $(this).addClass("active");
        $(".list-members .item-member.active").removeClass("active");
        $($(".list-members .item-member")[index]).addClass("active");
        let link = $(".list-icon-members .icon-member.active").data('hover')
        $(".list-icon-members .icon-member.active").css({
            'background-image': `url(${link})`,
        }).fadeIn();
        $(".list-icon-members .icon-member.active").find('img').attr('src', link)
    })

    //init
    $($(".list-icon-members .icon-member")[0]).addClass("active");
    let link = $(".list-icon-members .icon-member.active").data('hover')
    $(".list-icon-members .icon-member.active").css({
        'background-image': `url(${link})`,
    })
    $(".list-icon-members .icon-member.active").find('img').attr('src', link)
    $($(".list-members .item-member")[0]).addClass("active");


    //mouse move
    $(".inside .we-are .image").mousemove(function(event) {
        var offset = $(this).offset();
        //const $parent = $(this).parent();
        const pw = $(this).width()
        const ph = $(this).height()
        x = event.pageX- offset.left;
        y = event.pageY- offset.top;
        bw = $(this).find(".text").width();
        bh = $(this).find(".text").height();

        let newTop = y - bh/2;
        let newLeft = x - bw/2;

        if(newTop < 0) newTop = 0;
        if(newTop > ph) newTop = ph;
        if(newLeft < 0) newLeft = 0;
        if(newLeft > pw) newLeft = pw;

        $(this).find(".text").css({
            top: newTop,
            left: newLeft
        })
    });
}
module.exports = inside
